import React, { useState } from "react";
import classes from "./Modal.module.css";

const Modal = (props) => {
	const { error, selectedAddress } = props;
	const [email, setEmail] = useState("");

	const closeModalIcon = () => {
		props.onClose();
	};

	let address = "";
	if(selectedAddress) {
		address = selectedAddress.substr(0, selectedAddress.indexOf(','))
	}
	
	return (
		<div
			className={classes.Modal}
			style={{
				transform:props.opened ? 'translateY(0)' : 'translateY(-100vh)',
				opacity : props.opened ? 1 : 0
			}}
		>
			<div
				className={classes.closeModalIcon}
				onClick={closeModalIcon}
			>
				<img src="/images/icons/cross.svg" alt="close"/>
			</div>

			<div>Sign up to receive fire alerts for this location.</div>
			
			<form className={classes.form} noValidate autoComplete="off">
				<div className={classes.inputContainer}>
					<input
						type="text"
						className={classes.input}
						placeholder="E-mail address..."
						onChange={(event) => setEmail(event.target.value)}
						style={error ? { borderBottom: "1px solid red" } : {}}
					/>

					<div className={classes.address}>
						{address}
					</div>
				</div>
				
				<button
					className={classes.loginButton}
					onClick={(event) => props.onSubmit(event, email)}
				>
					Submit
				</button>
			</form>
			
			
		</div>
	);
};

export default Modal;
